import { NgModule } from '@angular/core';
import { NgClass } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { FuseVerticalNavigationBasicItemComponent } from '../basic/basic.component';
import { FuseVerticalNavigationCollapsableItemComponent } from './collapsable/collapsable.component';
import { FuseVerticalNavigationDividerItemComponent } from '../divider/divider.component';
import { FuseVerticalNavigationSpacerItemComponent } from '../spacer/spacer.component';
import { TranslocoPipe } from '@jsverse/transloco';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FuseVerticalNavigationGroupItemComponent } from './group/group.component';

@NgModule({
    declarations: [
        FuseVerticalNavigationCollapsableItemComponent,
        FuseVerticalNavigationGroupItemComponent
    ],
    imports: [
        NgClass,
        MatTooltipModule,
        MatIconModule,
        FuseVerticalNavigationBasicItemComponent,
        FuseVerticalNavigationDividerItemComponent,
        FuseVerticalNavigationSpacerItemComponent,
        TranslocoPipe,
    ],
    exports: [
        FuseVerticalNavigationCollapsableItemComponent,
        FuseVerticalNavigationGroupItemComponent
    ]
})
export class FuseVerticalNavigationItemModule {}
